import React, {Component} from 'react';

export default function scrollBreak(Element) {
    class ScrollBreak extends Component {
        constructor(props) {
            super(props);

            this.isEnabled = true;

            this.enable = this.enable.bind(this);
            this.disable = this.disable.bind(this);
            this.registerTarget = this.registerTarget.bind(this);
            this.onSafariTouchStart = this.onSafariTouchStart.bind(this);
            this.isEditableOnFocus = this.isEditableOnFocus.bind(this);
            this.onSafariTouchMove = this.onSafariTouchMove.bind(this);
            this.onSafariTouchEnd = this.onSafariTouchEnd.bind(this);
        }

        registerTarget(target) {
            if (!(this.props.scrollBreakProps || {}).disable) {
                if (target) {
                    target.addEventListener('touchstart', this.onSafariTouchStart, {passive: false});
                    target.addEventListener('touchmove', this.onSafariTouchMove, {passive: false});
                    target.addEventListener('touchend', this.onSafariTouchEnd, {passive: false});
                } else if (this.target) {
                    this.target.removeEventListener('touchstart', this.onSafariTouchStart, {passive: false});
                    this.target.removeEventListener('touchmove', this.onSafariTouchMove, {passive: false});
                    this.target.removeEventListener('touchend', this.onSafariTouchEnd, {passive: false});
                }

                this.target = target;
            }
        }

        onSafariTouchStart(event) {
            if (this.target) {
                this.allowUp = (this.target.scrollTop > 0);
                this.allowDown = (this.target.scrollTop < this.target.scrollHeight - this.target.clientHeight);
                this.slideBeginY = event.changedTouches[0].pageY;
                this.slideLastY = event.changedTouches[0].pageY;
            }
        }

        isEditableOnFocus() {
            return (document.activeElement.tagName === 'DIV' &&
                document.activeElement.getAttribute('contenteditable') === 'true') ||
                document.activeElement.tagName === 'TEXTAREA' ||
                document.activeElement.tagName === 'INPUT';
        }

        onSafariTouchMove(event) {
            if (this.target) {
                const up = (event.changedTouches[0].pageY > this.slideLastY);
                const down = (event.changedTouches[0].pageY < this.slideLastY);
                if ((up && this.allowUp) || (down && this.allowDown)) {
                    event.stopPropagation();
                } else if (!this.isEditableOnFocus()) {
                    event.preventDefault();

                    if (this.isEnabled) {
                        // Super simple elastic scroll simulation
                        //
                        let deltaY = event.changedTouches[0].pageY - this.slideBeginY;
                        deltaY = deltaY / 2;
                        this.target.style.transition = null;
                        this.target.style.transform = `translateY(${deltaY}px)`;
                        this.bounceBackOnEnd = true;
                    }
                }

                this.slideLastY = event.changedTouches[0].pageY;
            }
        }

        onSafariTouchEnd() {
            if (this.target && this.bounceBackOnEnd) {
                this.target.style.transition = 'transform 0.5s ease-out';
                this.target.style.transform = 'translateY(0px)';
                this.bounceBackOnEnd = false;

                if (this.clearAnimationTimer) {
                    clearTimeout(this.clearAnimationTimer);
                }

                this.clearAnimationTimer = setTimeout(() => {
                    if (this.target && this.target.style) {
                        this.target.style.transition = null;
                        this.target.style.transform = null;
                    }
                    this.clearAnimationTimer = null;
                }, 500);
            }
        }

        disable() {
            this.isEnabled = false;
        }

        enable() {
            this.isEnabled = true;
        }

        render() {
            return <Element
                {...this.props}
                scrollBreak={{
                    registerTarget: this.registerTarget,
                    disable: this.disable,
                    enable: this.enable,
                }}/>;
        }
    }

    ScrollBreak.displayName = 'ScrollBreak';

    return ScrollBreak;
}
